import * as $runtime from "../runtime.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Restaumatic$dAnalytics$dTracking$dAnalyticsV4 from "../Restaumatic.Analytics.Tracking.AnalyticsV4/index.js";
import * as Restaumatic$dAnalytics$dTracking$dEvent from "../Restaumatic.Analytics.Tracking.Event/index.js";
import * as Restaumatic$dAnalytics$dTracking$dFacebook from "../Restaumatic.Analytics.Tracking.Facebook/index.js";
import * as Utils$dTracking$dAnalyticsV3 from "../Utils.Tracking.AnalyticsV3/index.js";
import {getCurrencyEff, trackEventEff, trackEventUniqueEff} from "./foreign.js";
const toNamedEvent = currency => ev => (
  {
    analytics_v3: (() => {
      const $0 = Utils$dTracking$dAnalyticsV3.toPlatformEvent(currency)(ev);
      if ($0.tag === "Nothing") { return Data$dNullable.null; }
      if ($0.tag === "Just") { return Data$dNullable.notNull($0._1); }
      $runtime.fail();
    })(),
    analytics_v4: Data$dNullable.notNull(Restaumatic$dAnalytics$dTracking$dAnalyticsV4.toPlatformEvent(currency)(ev)),
    facebook_v2: (() => {
      const $0 = Restaumatic$dAnalytics$dTracking$dFacebook.toPlatformEvent(currency)(ev);
      if ($0.tag === "Nothing") { return Data$dNullable.null; }
      if ($0.tag === "Just") { return Data$dNullable.notNull($0._1); }
      $runtime.fail();
    })(),
    restaumatic: Restaumatic$dAnalytics$dTracking$dEvent.toPlatformEvent(ev)
  }
);
const trackEvent = dictMonadEffect => event => dictMonadEffect.liftEffect(() => {
  const currency = getCurrencyEff();
  return trackEventEff(toNamedEvent(currency)(event))();
});
const trackEventUnique = dictMonadEffect => eventKey => event => dictMonadEffect.liftEffect(() => {
  const currency = getCurrencyEff();
  return trackEventUniqueEff(eventKey)(toNamedEvent(currency)(event))();
});
export {toNamedEvent, trackEvent, trackEventUnique};
export * from "./foreign.js";
